import { Component } from '@angular/core';
import { SharedService } from '@app/shared/services/shared.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  year = new Date().getFullYear();
  socialLinks: {
    title: string;
    url: string;
    icon: string;
  }[];
  constructor(
    private sharedService: SharedService,
  ) {
    this.socialLinks = this.sharedService.socialLinks;
  }
}
